import { CountDown } from 'src/components/DateAndTime/CountDown';
import React from 'react';

export const timedAuctionGetEndMessage = (now, endDate) => {
  if(now.isAfter(endDate)) {
    return (<>Ended: {endDate.format('MMM Do, hh:mmA z')}</>);
  }
  if(endDate.diff(now, 'h') < 24) {
    return (<CountDown preText={'Ends in: '} endTime={endDate}/>);
  }
  return (<>Ends: {endDate.format('MMM Do, hh:mmA z')}</>);
};
